module.exports = __webpack_public_path__ + "static/media/shopping-basket-add-icon.59ca07ed.png";